import 'css-chunk:src/event-selection/EventGroupHeader.module.scss';export default {
  "headerWrapper": "_headerWrapper_1tm4l_1",
  "headerText": "_headerText_1tm4l_19",
  "expandIcon": "_expandIcon_1tm4l_25",
  "rotate": "_rotate_1tm4l_32",
  "checkboxWrapper": "_checkboxWrapper_1tm4l_36",
  "checkbox": "_checkbox_1tm4l_36"
};